// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select {
  font-size: 12px;
  min-height: 40px;
  width: 100%;
  --border-color: none;
  --padding-start: 0px;
  --padding-end: 0px;
}

ion-popover {
  --width: 250px;
}

ion-item.website-select {
  font-size: 10px;
  --border-width: 1px;
  --border-color: var(--ion-color-medium-tint);
  --border-radius: 5px;
}
ion-item.website-select ion-icon, ion-item.website-select img {
  width: 18px;
  height: 18x;
  margin-right: 10px;
}
ion-item.website-select ion-select {
  width: 100%;
}
ion-item.website-select ion-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--ion-color-secondary);
}
ion-item.website-select {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menus/menu-website-admin/menu-website-admin.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,oBAAA;AACJ;AAAI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AAER;AAAI;EACI,WAAA;AAER;AAAI;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;AAER;AAlBA;EAkBI,mBAAA;AAGJ","sourcesContent":["ion-select{\r\n    font-size: 12px;\r\n    min-height: 40px;\r\n    width: 100%;\r\n    --border-color: none;\r\n    --padding-start: 0px;\r\n    --padding-end: 0px;\r\n}\r\n\r\nion-popover  {\r\n    --width: 250px;\r\n}\r\n\r\nion-item.website-select {\r\n    font-size: 10px;\r\n    --border-width: 1px;\r\n    --border-color: var(--ion-color-medium-tint);\r\n    --border-radius: 5px;\r\n    ion-icon, img {\r\n        width: 18px;\r\n        height: 18x;\r\n        margin-right: 10px;\r\n    }\r\n    ion-select {\r\n        width: 100%;\r\n    }\r\n    ion-label {\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        color: var(--ion-color-secondary);\r\n    }\r\n    margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
